import { Flex, Badge } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { getStudyStatusStyle } from '../../services/studies';

const StudyTrackerStatusBadge = ({ value, data, isInJobsTable }) => {
    const status = getStudyStatusStyle(value);

    return (
        <Flex align="flex-start" pb="10px">
            <Badge variant={status.style.badgeVariant} colorScheme={status.style?.colorScheme}>
                {!!value ? (
                    <>
                        {isInJobsTable ? (
                            <>{value}</>
                        ) : (
                            <FormattedMessage
                                id="study_tracker_study_status"
                                values={{ status: value, percentComplete: data.percentComplete }}
                            />
                        )}
                    </>
                ) : (
                    'N/A'
                )}
            </Badge>
        </Flex>
    );
};

export default StudyTrackerStatusBadge;
